// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8aeffd1c","300":"fcc4ace6","389":"6d36b409","453":"d5aebdcc","457":"0cf80e7f","551":"f4a4cdde","732":"3667d026","842":"729cb4fd","851":"03202f67","977":"120ae08f","995":"0fa82509"}[chunkId] + ".chunk.js";
};